<div class="activity-stream-multiple-items-container">
  <coin-v2-button
    [type]="'secondary'"
    [icon]="'expand_more'"
    [text]="'activity-stream.show-btn' | translate"
    (click)="onShowClicked($event)"></coin-v2-button>

  @if (showDetails()) {
    <div
      #overlay
      class="changed-properties mat-elevation-z2"
      animate.enter="fade-in"
      animate.leave="fade-out"
      (click)="onOverlayClicked($event)">
      @for (item of filteredItems(); track item.propertyName) {
        <div
          class="changed-property"
          [class.no-changes]="item.originalValue === item.currentValue">
          <ng-container
            [ngTemplateOutlet]="isEmployeeChange(item) ? employeeChange : textChange"
            [ngTemplateOutletContext]="{ item }" />
        </div>
      }
    </div>
  }
</div>

<ng-template
  #textChange
  let-item="item">
  <div class="left">
    <p>
      {{
        isDisplayedUnformatted(item)
          ? item?.originalValue
          : (($safeNavigationMigration(item?.originalValue) | translate | formatUnknownValue) ?? '-')
      }}
    </p>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>
  <div class="right">
    <p>{{ item.propertyName | enumToText }}:</p>
    <p class="bold">
      {{
        isDisplayedUnformatted(item) ? item?.currentValue : ($safeNavigationMigration(item?.currentValue) | translate | formatUnknownValue) || '-'
      }}
    </p>
  </div>
</ng-template>

<ng-template
  #employeeChange
  let-item="item">
  @let originalEmployee = $safeNavigationMigration(item?.originalValue) | employeeId$ | async;
  @let currentEmployee = $safeNavigationMigration(item?.currentValue) | employeeId$ | async;

  <div class="left">
    @if (originalEmployee) {
      <coin-siemens-energy-employee-preview
        [employee]="originalEmployee"
        [showGid]="true"></coin-siemens-energy-employee-preview>
    } @else {
      <p>-</p>
    }
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>

  <div class="right">
    <p>{{ nameEmployeeProperty($safeNavigationMigration(item?.propertyName)) | enumToText }}:</p>
    @if (currentEmployee) {
      <coin-siemens-energy-employee-preview
        [employee]="currentEmployee"
        [showGid]="true"></coin-siemens-energy-employee-preview>
    } @else {
      <p>-</p>
    }
  </div>
</ng-template>
